import { getUserInfoApi } from '@/api/v1/organization/users/getUserInfoApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { logoutApi } from '@/api/v1/users/logoutApi';
import { SearchRoleType, getSearchUsersApi } from '@/api/v1/organization/users/getSearchUsersApi';
import { getSelfUserDetailsApi } from '@/api/v1/users/getSelfUserDetailsApi';
import { EditSelfUserDetailsPayloadType, editSelfUserDetailsApi } from '@/api/v1/users/editSelfUserDetailsApi';
import { getBillingPlanDetailsApi } from '@/api/v1/billing/getBillingPlanDetailsApi';

export const searchUsers = async (email: string, role?: SearchRoleType) => {
  const payload = {
    email,
    ...(role && { role }),
  };

  try {
    const response = await getSearchUsersApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const loadUserInfo = async (userId: string) => {
  try {
    const response = await getUserInfoApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const loadSelfUserDetails = async () => {
  try {
    const response = await getSelfUserDetailsApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const editSelfUserDetails = async (data: EditSelfUserDetailsPayloadType) => {
  try {
    const response = await editSelfUserDetailsApi(data);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const logout = async () => {
  try {
    const response = await logoutApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getBillingPlanDetails = async (planId: string) => {
  try {
    const response = await getBillingPlanDetailsApi(planId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
